import { render, staticRenderFns } from "./NavigationMailbox.vue?vue&type=template&id=a8bc7822&scoped=true"
import script from "./NavigationMailbox.vue?vue&type=script&lang=js"
export * from "./NavigationMailbox.vue?vue&type=script&lang=js"
import style0 from "./NavigationMailbox.vue?vue&type=style&index=0&id=a8bc7822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bc7822",
  null
  
)

export default component.exports